<tui-root>
  <app-page-loader></app-page-loader>
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
  @if (message;) {
    <div>
      <h1>{{ message.notification.title }}</h1>
      <h2>{{ message.notification.body }}</h2>
    </div>
  }
  <!-- <div class="wrapper" style="margin-left: 300px;margin-bottom: 100px;">
  <tui-push type="Show Management Event" class="push" [timestamp]="1661358075379" (close)="onClose()">
    <tui-svg class="human" src="@tui.check-square"></tui-svg>
    A new Show for <i>Dallas</i> is created.
    <button tuiButton type="button">Show me details</button>
    <button tuiLink type="button">
      Close
    </button>
  </tui-push>
</div> -->
<br><br><br><br><br><br>
</tui-root>